import { observer } from 'mobx-react-lite';
import { Card, Col, Row, Tag } from 'antd';
import './eiq-gate-management.scss';
import { Fragment, useEffect, useState } from 'react';
import configurationStore from 'common/stores/configuration/configuration.store';
import { IGateConfiguration } from 'common/services/configuration-service/configuration.service.types';
import { ICardAccessPanel } from 'common/services/card-access-service/card-access.service.types';
import cardAccessService from 'common/services/card-access-service/card-access.service';
import dayjs from 'dayjs';
import { EiqLiveActivity } from './live-activity/eiq-live-activity';
import featureStore from 'common/stores/features/feature.store';
import { GateManagementInstructions, GateReaderOptions, GateRelayOptions } from 'common/components/gate-controls/gate-control-options';
import { useGateControls } from 'common/components/gate-controls/use-gate-controls';

const EIQGateManagement = observer(() => {
  const gates = configurationStore.configuration?.gates.filter((i) => i.useGateController);
  const controls = useGateControls();
  const [panels, setPanels] = useState<ICardAccessPanel[]>([]);

  const getPanelState = (panelNumber: number | null) => {
    if (!panelNumber) {
      return 'Not configured';
    }

    const panel = panels.find((p) => p.panelNumber === panelNumber);

    if (!panel) {
      return 'Not configured';
    }

    const state = panel.description?.match(/State:\s*([^,]*)/)?.[1].trim() ?? '';

    return state;
  };

  const getRelayOptionsSecton = (gate: IGateConfiguration) => {
    if (!gate.relays) {
      return <></>;
    }

    return (
      <>
        <div className="h2">Relays</div>
        <GateRelayOptions gate={gate} controls={controls} nameTag="div" />
      </>
    );
  };

  const getGateOptionsSection = (gate: IGateConfiguration) => {
    if (!gate.readers) {
      return <></>;
    }

    return (
      <div>
        <div className="h2">Doors</div>
        <GateReaderOptions gate={gate} controls={controls} nameTag="div" />
      </div>
    );
  };

  useEffect(() => {
    const loadPanels = () => {
      cardAccessService
        .getPanels()
        .then((result) => {
          setPanels(result);
        })
        .catch(console.error);
    };

    loadPanels();

    //5 min
    const intervalId = setInterval(loadPanels, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  const getPanelStatusTag = (panelNumber: string | null) => {
    const status = getPanelState(panelNumber ? Number(panelNumber) : null);
    const className = status === 'Normal' ? 'success' : 'error';

    return <Tag className={className}>{status}</Tag>;
  };

  const getGateSection = (gate: IGateConfiguration) => {
    return (
      <div className="gate-wrapper">
        <div className="h1">{gate.name}</div>
        <div className="panel-status">
          Panel #{gate.panelNumber} {getPanelStatusTag(gate.panelNumber)}
          <span>{dayjs().format('M/D/YYYY h:mmA')}</span>
        </div>
        <div>{getGateOptionsSection(gate)}</div>
        <div>{getRelayOptionsSecton(gate)}</div>
      </div>
    );
  };

  return (
    <div className="eiq-gate-management-wrapper">
      <Card className="eiq-card-border" style={{ width: featureStore.isEIQLiveEnabled ? '70%' : '100%' }}>
        <Row className="eiq-card-header row-column">
          <Col>
            <div className="description">
              <h1 className="h1">GATE MANAGEMENT</h1>
              <GateManagementInstructions />
            </div>
            <div style={{ maxHeight: 820, overflowY: 'auto' }}>
              {gates?.map((gate, index) => (
                <Fragment key={`${gate.panelNumber}:${gate.name}:${index}`}>{getGateSection(gate)}</Fragment>
              ))}
            </div>
          </Col>
        </Row>
      </Card>
      {featureStore.isEIQLiveEnabled && (
        <Card className="eiq-card-border" style={{ width: '30%' }}>
          <Col>
            <EiqLiveActivity />
          </Col>
        </Card>
      )}
    </div>
  );
});

export default EIQGateManagement;
